var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user_layout"},[_c('main',{staticClass:"layout_center"},[_c('router-view'),_c('div',{staticClass:"back",on:{"click":_vm.back}},[_c('a-icon',{attrs:{"type":"left"}}),_c('span',[_vm._v("返回登录")])],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }